import { ICardReference, ICard, CardSubType } from "./Card";
import { IInvestigatorInPlay, IScenarioState } from "./Scenario";
import { CardUtil } from "./CardUtil";



export class InvestigatorUtil {
    //checks if the supplied card is a standard card for the supplied investigator or an temporary extra.
    static isPlayerCard(investigator: IInvestigatorInPlay, card: ICard): boolean {
        //normal cards are ok
        switch (card.subType) {
            case CardSubType.Neutral:
            case CardSubType.Guardian:
            case CardSubType.Seeker:
            case CardSubType.Rouge:
            case CardSubType.Mystic:
            case CardSubType.Survivor:
                return true;
        }
        //cards allowed based on description on investigator card are ok
        let playerFreeCards: ICardReference[] = investigator.card.values["freeCards"];
        //also freeCards gained in scenarios are ok
        if (investigator.freeCards)
            playerFreeCards = playerFreeCards.concat(investigator.freeCards);
        if (playerFreeCards.some(cr => CardUtil.equals(cr, card))) return true;
        //all other cards (random weakness etc. are not)
        return false;
    }
    static sortInvestigators(a: IInvestigatorInPlay, b: IInvestigatorInPlay) {
        if (a.order === undefined) return 1;
        if (b.order === undefined) return -1;
        return a.order - b.order;
    }
    static getInvestigatorsOnLocation(state: IScenarioState, locationId: number) {
        const investigators = state.investigators.filter(inv => inv.locationId === locationId);
        investigators.sort(this.sortInvestigators);
        return investigators;
    }
    static moveInvestigatorToLast(state: IScenarioState, locationId: number, index: number) {
        const investigators = this.getInvestigatorsOnLocation(state, locationId);
        if (index >= investigators.length) {
            return;
        }
        investigators[index].order = investigators.length - 1;
        for (let i = index + 1; i < investigators.length; i++) {
            investigators[i].order = i - 1;
        }
    }
    static getInvestigatorLocationIndex(state: IScenarioState, locationId: number, playerIndex: number) {
        const player = state.investigators[playerIndex];
        const investigatorsOnLocation = this.getInvestigatorsOnLocation(state, locationId);
        return investigatorsOnLocation.indexOf(player);
    }
}